// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.flex[data-v-309b1d4b] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.el-form-item[data-v-309b1d4b] {\n  margin-bottom: 5px;\n}\n.el-form-item .el-form-item[data-v-309b1d4b] {\n  margin-bottom: 0;\n}\n.demo-ruleForm[data-v-309b1d4b] .el-form-item__error {\n  position: sticky;\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
